// extracted by mini-css-extract-plugin
export default {"cta":"VI-z","disabled":"WI-z"};